(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
(function(){function setup(){var button=document.querySelector('.pn-chart-open');var dialog=document.querySelector('.pn-size-dialog');var source=document.querySelector('.pn-size-chart-content');if(!button||!dialog||!source||dialog.dataset.ready)return;dialog.dataset.ready='true';dialog.querySelector('.pn-chart-body').appendChild(source);button.addEventListener('click',function(){dialog.showModal();});dialog.querySelector('.pn-chart-close').addEventListener('click',function(){dialog.close();});dialog.addEventListener('close',function(){button.focus();});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup);})();

(function(){
  function init(){
    const section=document.getElementById('ProductSection');
    if(!section||section.dataset.pnPresentationReady)return;
    section.dataset.pnPresentationReady='true';
    const dialog=section.querySelector('.pn-photo-dialog');
    const opener=section.querySelector('.pn-enlarge-photo');
    if(dialog&&opener){
      const image=dialog.querySelector('.pn-photo-dialog__image');
      const zoom=dialog.querySelector('.pn-photo-zoom');
      opener.addEventListener('click',function(){
        const selected=Array.from(section.querySelectorAll('.product-single__featured-image-wrapper')).find(el=>!el.classList.contains('hidden'));
        const source=selected&&selected.querySelector('.product-single__photo');
        if(!source)return;
        image.src=source.dataset.fullImage||source.currentSrc||source.src;image.alt=source.alt;
        dialog.classList.remove('is-zoomed');zoom.setAttribute('aria-pressed','false');dialog.showModal();
      });
      dialog.querySelector('.pn-photo-close').addEventListener('click',()=>dialog.close());
      zoom.setAttribute('aria-pressed','false');
      zoom.addEventListener('click',()=>{const on=dialog.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(on));});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      dialog.addEventListener('close',()=>opener.focus());
    }
    const summary=section.querySelector('.pn-product-review-summary');
    if(!summary)return;
    let frame;
    const update=function(){
      const widget=document.getElementById('reviews-importify-reviews');
      const rating=widget&&widget.querySelector('.ri_total_reviews');
      const count=widget&&widget.querySelector('.average_rating_text');
      const value=rating&&rating.textContent.trim();
      const caption=count&&count.textContent.replace(/\s+/g,' ').trim();
      const match=caption&&caption.match(/\d[\d,]*/);
      const valid=value&&/^\d(?:\.\d+)?\s*\/\s*5$/.test(value)&&match&&Number(match[0].replace(/,/g,''))>0&&widget.querySelector('.ri-reviews-row');
      if(!valid){summary.hidden=true;const legacy=document.getElementById('shopify-product-reviews');if(legacy)legacy.hidden=false;return;}
      if(summary.querySelector('.pn-review-rating').textContent!==value)summary.querySelector('.pn-review-rating').textContent=value;
      if(summary.querySelector('.pn-review-count').textContent!==caption)summary.querySelector('.pn-review-count').textContent=caption;
      summary.hidden=false;
      const legacy=document.getElementById('shopify-product-reviews');if(legacy)legacy.hidden=true;
    };
    const observer=new MutationObserver(()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);});
    observer.observe(document.body,{childList:true,subtree:true,characterData:true});update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
